<ng-container *ngIf="(cadArquivoOnline$ | async) as arquivo; else semPreview">
  <ng-container *ngIf="arquivo?.presignedUrl; else semPreview">
    <div class="file-preview-wrapper">
      <a class="download-link" target="_blank" [href]="arquivo?.presignedUrl" rel="noopener">
        Baixar: {{ arquivo?.fileName }}
      </a>

      <div *ngIf="isImage$ | async" class="image-preview-wrap">
        <img class="image-preview" [src]="arquivo?.presignedUrl" [alt]="arquivo?.fileName || 'Imagem anexa'" />
      </div>

      <div *ngIf="isPdf(arquivo?.contentType)" class="pdf-preview-wrap">
        <div class="pdf-controls" fxLayout="row" fxLayoutAlign="center center">
          <button mat-icon-button (click)="firstPage()" [disabled]="currentPage === 1">
            <mat-icon>first_page</mat-icon>
          </button>
          <button mat-icon-button (click)="previousPage()" [disabled]="currentPage === 1">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <span class="page-indicator">{{ currentPage }} / {{ totalPages }}</span>
          <button mat-icon-button (click)="nextPage()" [disabled]="currentPage === totalPages">
            <mat-icon>chevron_right</mat-icon>
          </button>
          <button mat-icon-button (click)="lastPage()" [disabled]="currentPage === totalPages">
            <mat-icon>last_page</mat-icon>
          </button>
        </div>

        <div #pdfContainer class="pdf-canvas-wrap">
          <canvas #pdfViewer></canvas>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #semPreview>
  <div class="no-preview">Nenhuma visualização disponível!</div>
</ng-template>

